import { Box, useMediaQuery } from "@mui/material"
import { FileResponse } from "../../types/FileResponse";
import React from "react";

type PhotoDisplayProps = {
    photo: FileResponse | undefined;
    photoLoading: boolean;
};

const PhotoDisplay = ({ photo, photoLoading }: PhotoDisplayProps) => {
    const isLessThan500 = useMediaQuery('(max-width:580px)');

    return (
        <>
        {photo !== undefined && !photoLoading &&
            <Box
                component="img"
                alt={'Artist Photo'}
                sx={{ width: isLessThan500 ? '100%' : '280px', border: '2px solid #d8d8d8', borderRadius: '8px' }}
                src={`data:image/jpeg;base64,${photo?.fileContents}`}
            />
        }
        </>
    );
}

export default PhotoDisplay;
